import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import api from "../../../services/api";

const fmt  = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmt4 = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:4});
const n    = (v) => parseFloat(v) || 0;

const GRUPOS = {
  SEMIACABADO: [
    { label:"Pecas Injetadas",   filter: p => p.categoria==="INJECAO_PLASTICA" },
    { label:"Cordas Trancadas",  filter: p => p.categoria==="TRANCAGEM_CORDA" },
    { label:"Pecas Metalicas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="PECA_MET" },
    { label:"Pecas Plasticas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="ITEM_PLASTICO" },
    { label:"Semiacabados",      filter: p => p.categoria==="SEMIACABADO" },
  ],
  MONTAGEM_VARAL: [
    { label:"Perfis Cortados",   filter: p => p.categoria==="CORTE_BARRA_ALU" },
    { label:"Pecas Metalicas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="PECA_MET" },
    { label:"Pecas Plasticas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="ITEM_PLASTICO" },
    { label:"Semiacabados/Kits", filter: p => p.categoria==="SEMIACABADO" },
  ],
  MONTAGEM_KIT: [
    { label:"Semiacabados",      filter: p => p.categoria==="SEMIACABADO" },
    { label:"Pecas Injetadas",   filter: p => p.categoria==="INJECAO_PLASTICA" },
    { label:"Pecas Metalicas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="PECA_MET" },
    { label:"Pecas Plasticas",   filter: p => p.categoria==="COMP_COMPRADO" && p.tipo==="ITEM_PLASTICO" },
    { label:"Cordas Trancadas",  filter: p => p.categoria==="TRANCAGEM_CORDA" },
  ],
  PRODUTO_FINAL: [
    { label:"Montagens",         filter: p => p.grupo==="MONTAGEM" },
  ],
};

const PreviewBox = ({children}) => (
  <div style={{background:"#eef2ff",border:"1px solid #c7d2fe",borderRadius:6,padding:"10px 14px",marginBottom:12,fontSize:12,display:"flex",gap:20,flexWrap:"wrap",alignItems:"center"}}>
    {children}
  </div>
);
const PreviewItem = ({label, value, destaque}) => (
  <span style={{color:destaque?"var(--z-blue)":"inherit"}}>
    {label}: <strong>{value}</strong>
  </span>
);

const FormMontagem = forwardRef(function FormMontagem({produto, allProdutos, funcionarios, onAtualizar}, ref) {
  const pm   = produto.processo_montagem || {};
  const pmId = pm.id || null;
  const cat  = produto.categoria;
  const grupos = GRUPOS[cat] || GRUPOS["SEMIACABADO"];

  const [composicao, setComposicao] = useState(produto.composicao || []);
  const [adicionando, setAdicionando] = useState(false);
  const [novoItem, setNovoItem]       = useState({componente:"", quantidade:"1", unidade:"un"});
  const [grupo, setGrupo]             = useState("TODOS");
  const [salvando, setSalvando]       = useState(false);
  const [editandoId, setEditandoId]   = useState(null);
  const [editQtd, setEditQtd]         = useState("");
  const [funcId, setFuncId]           = useState(pm.funcionario || "");
  const [tempoSeg, setTempoSeg]       = useState(pm.tempo_seg || "");
  const [salvandoMO, setSalvandoMO]   = useState(false);

  useEffect(() => {
    setComposicao(produto.composicao || []);
    setFuncId(produto.processo_montagem?.funcionario || "");
    setTempoSeg(produto.processo_montagem?.tempo_seg || "");
  }, [produto]);

  const prodDisp = allProdutos.filter(p => {
    if (p.id === produto.id) return false;
    if (grupo === "TODOS") return grupos.some(g => g.filter(p));
    const g = grupos.find(gr => gr.label === grupo);
    return g ? g.filter(p) : false;
  });

  const custoComp  = composicao.reduce((s,c) => s + n(c.custo_linha), 0);
  const func       = funcionarios.find(f => f.id === parseInt(funcId));
  const custoMO    = func && tempoSeg ? n(func.custo_hora) * n(tempoSeg) / 3600 : 0;
  const custoTotal = custoComp + custoMO;

  const adicionar = async () => {
    if (!novoItem.componente) return;
    setSalvando(true);
    try {
      await api.post("/produtos/composicao/", {
        produto: produto.id,
        componente: novoItem.componente,
        quantidade: novoItem.quantidade,
        unidade: novoItem.unidade,
      });
      setNovoItem({componente:"", quantidade:"1", unidade:"un"});
      setAdicionando(false);
      onAtualizar();
    } catch(e) { alert("Erro ao adicionar."); }
    finally { setSalvando(false); }
  };

  const salvarQtd = async (compId) => {
    setSalvando(true);
    try {
      await api.patch("/produtos/composicao/"+compId+"/", {quantidade: editQtd});
      setEditandoId(null);
      onAtualizar();
    } catch(e) { alert("Erro."); }
    finally { setSalvando(false); }
  };

  const remover = async (compId) => {
    if (!window.confirm("Remover este item?")) return;
    await api.delete("/produtos/composicao/"+compId+"/");
    onAtualizar();
  };

  const salvarMO = async () => {
    setSalvandoMO(true);
    const dados = {produto: produto.id, funcionario: funcId||null, tempo_seg: n(tempoSeg)};
    try {
      if (pmId) await api.put("/produtos/processo-montagem/"+pmId+"/", dados);
      else      await api.post("/produtos/processo-montagem/", dados);
      onAtualizar();
    } catch(e) { alert("Erro ao salvar MO."); }
    finally { setSalvandoMO(false); }
  };

  useImperativeHandle(ref, () => ({ salvar: salvarMO }));

  const compSel = allProdutos.find(p => p.id === parseInt(novoItem.componente));

  return (
    <div>
      {/* Lista de componentes estilo compacto */}
      {composicao.map(c => (
        <div key={c.id} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 0",borderBottom:"1px solid var(--z-border)",fontSize:12}}>
          <span style={{fontFamily:"monospace",fontSize:11,color:"var(--z-text-muted)",width:100,flexShrink:0}}>{c.componente_codigo}</span>
          <span style={{flex:1}}>{c.componente_nome}</span>
          <span style={{display:"flex",alignItems:"center",gap:4}}>
            {editandoId===c.id ? (
              <>
                <input type="number" style={{width:60,padding:"1px 4px",fontSize:12,border:"1px solid var(--z-blue)",borderRadius:4,textAlign:"right"}}
                  value={editQtd} onChange={e=>setEditQtd(e.target.value)} autoFocus />
                <button className="btn btn-primary" style={{padding:"1px 6px",fontSize:11}} disabled={salvando}
                  onClick={()=>salvarQtd(c.id)}>OK</button>
                <button className="btn btn-secondary" style={{padding:"1px 6px",fontSize:11}}
                  onClick={()=>setEditandoId(null)}>x</button>
              </>
            ) : (
              <span style={{cursor:"pointer",color:"var(--z-blue)",borderBottom:"1px dashed var(--z-blue)",minWidth:30,textAlign:"right"}}
                onClick={()=>{setEditandoId(c.id);setEditQtd(c.quantidade);}}>
                {fmt4(c.quantidade)}
              </span>
            )}
          </span>
          <span style={{color:"var(--z-text-muted)",width:30}}>{c.unidade}</span>
          <span style={{color:"var(--z-text-secondary)",width:80,textAlign:"right"}}>R$ {fmt4(c.componente_preco)}</span>
          <span style={{fontWeight:600,color:"var(--z-blue)",width:60,textAlign:"right"}}>R$ {fmt(c.custo_linha)}</span>
          <button className="btn btn-danger" style={{padding:"1px 6px",fontSize:10}}
            onClick={()=>remover(c.id)}><i className="ti ti-trash"/></button>
        </div>
      ))}

      {composicao.length > 0 && (
        <PreviewBox>
          <PreviewItem label="Custo materiais" value={"R$ "+fmt(custoComp)} />
          {custoMO > 0 && <PreviewItem label="MO" value={"R$ "+fmt4(custoMO)} />}
          {custoTotal > 0 && <PreviewItem label="TOTAL" value={"R$ "+fmt(custoTotal)} destaque />}
        </PreviewBox>
      )}

      {/* Adicionar componente */}
      {adicionando ? (
        <div style={{background:"#f0f4ff",border:"1px solid #c7d2fe",borderRadius:6,padding:"12px",marginBottom:8}}>
          <div style={{display:"flex",gap:6,marginBottom:8,flexWrap:"wrap"}}>
            {["TODOS",...grupos.map(g=>g.label)].map(g=>(
              <button key={g} className={"btn btn-secondary"+(grupo===g?" aba-ativa":"")} style={{fontSize:11,padding:"3px 10px"}}
                onClick={()=>setGrupo(g)}>{g}</button>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"3fr 1fr 1fr",gap:8,marginBottom:8}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Componente</label>
              <select className="form-select" value={novoItem.componente}
                onChange={e=>setNovoItem(v=>({...v,componente:e.target.value,
                  unidade:allProdutos.find(p=>p.id===parseInt(e.target.value))?.unidade||"un"}))}>
                <option value="">-- Selecione --</option>
                {prodDisp.map(p=>(
                  <option key={p.id} value={p.id}>{p.codigo} — {p.nome} (R${fmt4(p.preco_custo)}/{p.unidade})</option>
                ))}
              </select>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Quantidade</label>
              <input className="form-input" type="number" value={novoItem.quantidade}
                onChange={e=>setNovoItem(v=>({...v,quantidade:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Unidade</label>
              <select className="form-select" value={novoItem.unidade}
                onChange={e=>setNovoItem(v=>({...v,unidade:e.target.value}))}>
                {["un","m","kg","g","cm","mm"].map(u=><option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>
          {compSel && (
            <div style={{fontSize:12,color:"var(--z-text-secondary)",marginBottom:8}}>
              Custo estimado: <strong style={{color:"var(--z-blue)"}}>R$ {fmt(n(compSel.preco_custo)*n(novoItem.quantidade))}</strong>
            </div>
          )}
          <div style={{display:"flex",gap:8}}>
            <button className="btn btn-primary" style={{fontSize:12,padding:"5px 14px"}} disabled={salvando||!novoItem.componente}
              onClick={adicionar}><i className="ti ti-plus"/> {salvando?"Adicionando...":"Adicionar"}</button>
            <button className="btn btn-secondary" style={{fontSize:12,padding:"5px 14px"}}
              onClick={()=>setAdicionando(false)}>Cancelar</button>
          </div>
        </div>
      ) : (
        <button className="btn btn-secondary" style={{fontSize:12,padding:"4px 12px",marginBottom:8}}
          onClick={()=>setAdicionando(true)}>
          <i className="ti ti-plus"/> Adicionar componente
        </button>
      )}

      {/* Mao de obra numa linha */}
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:8,marginBottom:8,padding:"8px",background:"#fff",border:"1px solid var(--z-border)",borderRadius:6}}>
        <div className="form-group" style={{margin:0}}>
          <label className="form-label">Funcionario (MO)</label>
          <select className="form-select" value={funcId} onChange={e=>setFuncId(e.target.value)}>
            <option value="">-- Selecione --</option>
            {funcionarios.map(f=>(
              <option key={f.id} value={f.id}>{f.nome} (R${fmt4(f.custo_hora)}/h)</option>
            ))}
          </select>
        </div>
        <div className="form-group" style={{margin:0}}>
          <label className="form-label">Tempo montagem (seg)</label>
          <input className="form-input" type="number" value={tempoSeg}
            onChange={e=>setTempoSeg(e.target.value)} placeholder="Ex: 30" />
        </div>
      </div>
      <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:8}}>
        <button className="btn btn-primary" style={{fontSize:12,padding:"5px 14px"}} disabled={salvandoMO}
          onClick={salvarMO}>
          <i className="ti ti-device-floppy"/> {salvandoMO?"Salvando...":"Salvar MO"}
        </button>
        {custoMO > 0 && (
          <span style={{fontSize:12,color:"var(--z-text-secondary)"}}>
            Custo MO: <strong style={{color:"var(--z-blue)"}}>R$ {fmt4(custoMO)}/un</strong>
          </span>
        )}
      </div>
    </div>
  );
});

export default FormMontagem;
